import React, { Component } from 'react';
import * as actions from '../../../store/actions/index';
import { connect } from 'react-redux';
import classes from './NavigationItems.css';
import NavigationItem from './NavigationItem/NavigationItem';

class NavigationItems extends Component {
    state = {
        showSideDrawer: false
    }

    componentDidMount() {
        this.props.onGetMulchYear(); 
           
    };

    render () {
        return (
    <ul className={classes.NavigationItems}>
        <NavigationItem link="/" exact>Home</NavigationItem>
        {this.props.isAuthenticated && this.props.userType === 'scout' ? <NavigationItem link="/addOrder?0"> Add Order</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'admin' ? <NavigationItem link="/deliveries"> Deliveries</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'admin' ? <NavigationItem link="/drivers?0"> Drivers</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'scout' ? <NavigationItem link="/showOrders"> View Orders</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'scout' ? <NavigationItem link="/callList"> Call List</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'admin'? <NavigationItem link="/adminOrders?0"> Orders</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'admin'? <NavigationItem link="/adminScoutSummary"> Summary</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'admin'? <NavigationItem link="/adminCallList?0"> Previous</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'admin'? <NavigationItem link="/adminApprove"> Approve</NavigationItem> : null}
        {this.props.isAuthenticated && this.props.userType === 'admin'? <NavigationItem link="/pickupSummary?0"> Pickup</NavigationItem> : null}
        {this.props.isAuthenticated ? <NavigationItem link="/documents"> Documents</NavigationItem> : null}
        {!this.props.isAuthenticated
            ? <NavigationItem link="/auth">Authenticate</NavigationItem>
            : <NavigationItem link="/logout">Logout</NavigationItem>}
    </ul>
);
        }
    }

    const mapStateToProps = state => {
        return {
          mulchYear: state.orders.mulchYear,
          isAuthenticated: state.orders.token !== null,
          userType : state.orders.userType
    
        };
      };
      
    const mapDispatchToProps = dispatch => {
        return {
         
          onGetMulchYear: () => dispatch(actions.getMulchYear()),
        };
      };
      
      export default connect(mapStateToProps, mapDispatchToProps)(NavigationItems);


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.js